import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserStore } from 'journey-store';
import { NavService } from '0-app-desktop/service/nav-service';

export const AuthGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const userStore = inject(UserStore);
  const navService = inject(NavService);

  const authenticated = await userStore.isAuthenticated();
  if (authenticated) {
    return true;
  }

  if (state.url && state.url !== '/logout') {
    navService.setAfterLoginUrl(state.url);
  }

  return router.parseUrl('/login');
};
